// extracted by mini-css-extract-plugin
export default {"sidebarToggleButton":"Sidebar-module__sidebarToggleButton--d_AYi","sidebarHeading":"Sidebar-module__sidebarHeading--ysXOm"};